<script>
import { UserService } from "@/service";

export default {
	props: {
		// 标签数组
		dataSource: {
			default() {
				return [];
			},
		},
		// 用户详情
		infoData: {
			default() {
				return [];
			},
		},
		// 类型
		userType: {
			default: "",
		},
	},
	watch: {
		infoData: {
			immediate: true,
			// deep: true,
			handler(newValue, oldValue) {
				if (newValue && Object.keys(newValue).length > 0) {
					this.form = newValue;
				}
			},
		},
	},
	data() {
		return {
			form: {
				id: "",
				userType: "开发者",
				gender: "",
				age: "",
				developSoftware: [],
				developSoftwareOther: "",
				developLanguage: [],
				developLanguageOther: "",
				developPlatform: [],
				developPlatformOther: "",
				developMethod: [],
				developMethodOther: "",
				developDatabase: [],
				developDatabaseOther: "",
				developExperience: [],
				developExperienceOther: "",
				developType: "",
			},
			rules: {
				gender: [{ required: true, message: "请选择性别", trigger: "change" }],
				age: [{ required: true, message: "请选择年龄", trigger: "change" }],
			},
		};
	},
	mounted() {},
	methods: {
		setState(obj) {
			for (let key in obj) {
				this.form[key] = obj[key];
			}
		},
		formChange(value) {
			this.setState({
				value,
			});
		},
		async handleSubmit() {
			this.$message.info("提交中...");
			const res = await UserService.SaveDescription({ ...this.form, userType: this.userType });
			if (res.code == 0) {
				this.$message.success("提交成功");
				this.$emit("refresh");
			}
		},
		RadioChange(key, value) {
			this.form[key] = ["id", "userType", "gender", "age"].includes(key) ? value : [value];
		},
		SelectChange(key, value) {
			const data = this.form[key] || [];
			let index = data.indexOf(value);
			if (index > -1) {
				data.splice(index, 1);
			} else {
				if (data?.length >= 5) {
					this.$message.warning("最多选择5个");
				} else {
					data.push(value);
				}
			}
			this.setState({ [key]: data });
		},
	},
	render() {
		const { dataSource, form, rules } = this;
		return (
			<el-form class="design-form" props={{ model: form, rules: rules }} label-width={"110px"}>
				<el-form-item label="性别：" prop="gender">
					<span onClick={() => this.RadioChange("gender", 1)} class={`label-data ${1 === parseInt(form.gender, 10) ? "active" : ""}`}>
						男
					</span>
					<span onClick={() => this.RadioChange("gender", 2)} class={`label-data ${2 === parseInt(form.gender, 10) ? "active" : ""}`}>
						女
					</span>
				</el-form-item>
				<el-form-item label="年龄：" prop="age">
					{dataSource[9]
						? dataSource[9].map((item, index) => {
								return (
									<span
										class={`label-data ${item.id === parseInt(form.age, 10) ? "active" : ""}`}
										key={index}
										onClick={() => this.RadioChange("age", item.id)}>
										{item.tagName}
									</span>
								);
						  })
						: ""}
				</el-form-item>
				<el-form-item label="开发软件：">
					{(dataSource[0] || []).map((item, index) => {
						return (
							<span
								class={`label-data ${form.developSoftware.includes(item.id) ? "active" : ""}`}
								key={index}
								onClick={() => this.SelectChange("developSoftware", item.id)}>
								{item.tagName}
							</span>
						);
					})}
					{form.developSoftware.includes(18) ? (
						<el-input size="mini" placeholder="请输入..." v-model={form.developSoftwareOther} class="checkbox-other" />
					) : (
						""
					)}
				</el-form-item>
				<el-form-item label="开发语言：">
					{(dataSource[1] || []).map((item, index) => {
						return (
							<span
								class={`label-data ${form.developLanguage.includes(item.id) ? "active" : ""}`}
								key={index}
								onClick={() => this.SelectChange("developLanguage", item.id)}>
								{item.tagName}
							</span>
						);
					})}
					{form.developLanguage.includes(28) ? (
						<el-input size="mini" placeholder="请输入..." v-model={form.developLanguageOther} class="checkbox-other" />
					) : (
						""
					)}
				</el-form-item>
				<el-form-item label="开发平台：">
					{(dataSource[2] || []).map((item, index) => {
						return (
							<span
								class={`label-data ${form.developPlatform.includes(item.id) ? "active" : ""}`}
								key={index}
								onClick={() => this.SelectChange("developPlatform", item.id)}>
								{item.tagName}
							</span>
						);
					})}
					{form.developPlatform.includes(33) ? (
						<el-input size="mini" placeholder="请输入..." v-model={form.developPlatformOther} class="checkbox-other" />
					) : (
						""
					)}
				</el-form-item>
				<el-form-item label="开发方式：">
					{(dataSource[3] || []).map((item, index) => {
						return (
							<span
								class={`label-data ${form.developMethod.includes(item.id) ? "active" : ""}`}
								key={index}
								onClick={() => this.SelectChange("developMethod", item.id)}>
								{item.tagName}
							</span>
						);
					})}
					{form.developMethod.includes(38) ? (
						<el-input size="mini" placeholder="请输入..." v-model={form.developMethodOther} class="checkbox-other" />
					) : (
						""
					)}
				</el-form-item>
				<el-form-item label="数据库环境：">
					{(dataSource[4] || []).map((item, index) => {
						return (
							<span
								class={`label-data ${form.developDatabase.includes(item.id) ? "active" : ""}`}
								key={index}
								onClick={() => this.SelectChange("developDatabase", item.id)}>
								{item.tagName}
							</span>
						);
					})}
					{form.developDatabase.includes(42) ? (
						<el-input size="mini" placeholder="请输入..." v-model={form.developDatabaseOther} class="checkbox-other" />
					) : (
						""
					)}
				</el-form-item>
				<el-form-item label="开发经验：">
					{(dataSource[5] || []).map((item, index) => {
						return (
							<span
								class={`label-data ${item.id === parseInt(form.developExperience, 10) ? "active" : ""}`}
								key={index}
								onClick={() => this.RadioChange("developExperience", item.id)}>
								{item.tagName}
							</span>
						);
					})}
				</el-form-item>
				<el-form-item label="擅长开发类型：">
					<el-input
						size="mini"
						type="textarea"
						autosize={{ minRows: 4, maxRows: 4 }}
						placeholder="例如：钣金处理类、BOM清单处理类"
						v-model={form.developType}
					/>
				</el-form-item>
				<div style="text-align: center">
					<span class="label-data active btn" onClick={() => this.handleSubmit()}>
						确定
					</span>
				</div>
			</el-form>
		);
	},
};
</script>

<style lang="less" scoped>
@import "./skill.less";
</style>
